module.exports = __webpack_public_path__ + "img/2.3ad19193.jpg";